import React, { useState } from 'react'

type Props = {
    assignment_title: string;
}

type Score = {
    ged: number;
    diff: number;
    score: number;
    img: string;
    img1: string;
    img2: string;
}

const AssignmentReview = ({assignment_title}: Props): JSX.Element => {
    const [score, setScore] = useState(null as null | Score);

  return (
    <div>AssignmentReview</div>
  )
}

export default AssignmentReview